var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSidebarMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_845_16846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 6.0542C14.4375 4.15572 12.8985 2.6167 11 2.6167C9.10152 2.6167 7.5625 4.15572 7.5625 6.0542V11.5542C7.5625 13.4527 9.10152 14.9917 11 14.9917C12.8985 14.9917 14.4375 13.4527 14.4375 11.5542V6.0542Z",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 17.7417V20.4917",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 11.5542C17.1875 13.1952 16.5356 14.769 15.3752 15.9294C14.2148 17.0898 12.641 17.7417 11 17.7417C9.35897 17.7417 7.78516 17.0898 6.62478 15.9294C5.4644 14.769 4.8125 13.1952 4.8125 11.5542",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_845_16846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.554199)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSidebarMicrophone);
export default __webpack_public_path__ + "static/media/icon-sidebar-microphone.6d2d574c80bbd5a6edd328e561f709dd.svg";
export { ForwardRef as ReactComponent };